import { z } from 'zod';

export interface SidebarItem {
  readonly name: string;
  readonly link?: string;
  readonly children?: readonly SidebarItem[];
}

export const sidebarItemSchema: z.ZodType<SidebarItem> = z
  .object({
    name: z.string(),
    link: z.string().optional(),
    children: z.lazy(() => z.array(sidebarItemSchema)).optional(),
  })
  .passthrough();

export const sidebarSchema = z.array(sidebarItemSchema);

// View As still parks a sidebar under these keys until it moves to a server-side session; nothing reads them.
export const SIDEBAR_KEY = 'sideBar';

export const SIDEBAR_STORED_AT_KEY = 'sideBarAt';

export const visibleItems = (items: readonly SidebarItem[], canVisit: (to: string) => boolean): SidebarItem[] =>
  items.flatMap((item): SidebarItem[] => {
    const children = item.children ? visibleItems(item.children, canVisit) : undefined;
    const linkOpens = item.link !== undefined && canVisit(item.link);
    if (item.link !== undefined && !linkOpens) return [];
    if (item.link === undefined && (children === undefined || children.length === 0)) return [];
    return [{ ...item, ...(children ? { children } : {}) }];
  });

export const linksOf = (items: readonly SidebarItem[]): string[] =>
  items.flatMap((item) => [...(item.link !== undefined ? [item.link] : []), ...linksOf(item.children ?? [])]);
